import React from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { calculateCompletion, countNumFields, retrieveFieldKeys } from '../helpers';

export function useTealiumIdle(timeout?: number, customerType?: string) {
  const { getRemainingTime } = useIdleTimer({
    onIdle,
    timeout: timeout ?? 15_000,
    throttle: 500,
  });

  const [isIdle, setIsIdle] = React.useState(false);
  const [fieldCount, setFieldCount] = React.useState(0);
  const [counted, setCounted] = React.useState(false);

  let idleCount = 0;

  function onIdle() {
    if (Math.ceil(getRemainingTime() / 1000) === 0) {
      setIsIdle(true);
    }
  }

  const initFieldCount = <T extends {}>(fields: T, excludedFields?: string[]) => {
    if (!counted) {
      setFieldCount(countNumFields(fields, excludedFields));
      setCounted(true);
    }
  };

  const sendIdleEvent = <T extends {}>(
    values: T,
    tealiumEvent: (
      incompleteFields: string,
      formCompletionRate: string,
      customerType?: string,
    ) => void,
    excludedFields?: string[],
  ) => {
    if (isIdle && idleCount === 0) {
      const incompleteFields = retrieveFieldKeys(values, excludedFields, customerType);
      const completion = calculateCompletion(fieldCount, incompleteFields.length);
      tealiumEvent(completion === '100' ? '' : incompleteFields.join(' | '), completion);
      idleCount++;
    }
  };

  return { initFieldCount, sendIdleEvent };
}
